import {
  // ContractAddress,
  ContractAddressBinance,
  ContractAddressBinanceTest,
  PancakeSmartRouterV3ContractAddressBinanceMainnet,
  PancakeSmartRouterV3ContractAddressBinanceTestnet,
  PancakeV3QuoterV2ContractAddressBinanceMainnet,
  // UniswapRouterV2ContractAddress,
} from '@mogul/shared';
import type { Trade } from '@uniswap/sdk';
import { getPublicClient } from '@wagmi/core';
import BigNumber from 'bignumber.js';
import { ethers } from 'ethers';

import { pancakeswapAbi } from '../../abis/pancakeswap';
import { quoterAbi } from '../../abis/pancakeswapQuoter';
// import { uniswapAbi } from '../../abis/uniswap';
import { usdtAbi } from '../../abis/usdt';
import type { walletClientToSigner } from '../smart-contract-utils';
import {
  getStarsAddress,
  getWalletClientSafe,
  publicClientToProvider,
} from '../smart-contract-utils';

const PANCAKE_FEE = 500; // 0.05% pool

const swapRouterByNetwork: {
  [key: string]: { address: string; abi: any; usdtAddress: string };
} = {
  // MAINNET: {
  //   address: UniswapRouterV2ContractAddress,
  //   abi: uniswapAbi,
  //   usdtAddress: ContractAddress.Usdt as string,
  // },
  BINANCE: {
    address: PancakeSmartRouterV3ContractAddressBinanceMainnet,
    abi: pancakeswapAbi,
    usdtAddress: ContractAddressBinance.Usdt as string,
  },
  BSCTEST: {
    address: PancakeSmartRouterV3ContractAddressBinanceTestnet,
    abi: pancakeswapAbi,
    usdtAddress: ContractAddressBinanceTest.Usdt as string,
  },
};

const getAmountOutWithQuoter = async (
  provider: ethers.providers.Provider,
  trade: Trade,
) => {
  const quoterContract = new ethers.Contract(
    PancakeV3QuoterV2ContractAddressBinanceMainnet,
    quoterAbi,
    provider,
  );

  const [amountOut, gasEstimate] =
    await quoterContract.callStatic.quoteExactInputSingle([
      trade.route.path[0].address,
      trade.route.path[1].address,
      trade.inputAmount.raw.toString(),
      PANCAKE_FEE,
      '0',
    ]);

  console.log('Gas Estimate', gasEstimate.toString());

  return new BigNumber(amountOut.toString());
};

export const getPancakeTradeMinimumAmountOut = async (
  trade: Trade,
  slippageTolerance?: string,
) => {
  const publicClient = getPublicClient();
  const provider = publicClientToProvider(publicClient);

  const amountOutMin = await getAmountOutWithQuoter(provider, trade);

  if (slippageTolerance != null) {
    return amountOutMin
      .times(new BigNumber(10000).minus(new BigNumber(slippageTolerance)))
      .div(10000);
  }
  return amountOutMin;
};

export const swapExactUsdtForMogul = async (
  signer: ReturnType<typeof walletClientToSigner>,
  {
    amountOutMin,
    recipient,
    deadline,
    value,
    currentNetwork,
  }: {
    amountOutMin: string;
    recipient: string;
    deadline: number;
    value: string;
    currentNetwork: string;
  },
): Promise<string> => {
  const {
    address: contractAddress,
    abi: contractAbi,
    usdtAddress,
  } = swapRouterByNetwork[currentNetwork];
  const contract = new ethers.Contract(contractAddress, contractAbi, signer);

  const params = {
    tokenIn: usdtAddress,
    tokenOut: getStarsAddress(),
    fee: PANCAKE_FEE, // 0.05% pool
    recipient,
    deadline,
    amountIn: value, // USDT
    amountOutMinimum: amountOutMin, // Min Mogul
    sqrtPriceLimitX96: 0,
  };

  console.log(params);

  const usdtContract = new ethers.Contract(usdtAddress, usdtAbi, signer);

  const approvedValue = await usdtContract.allowance(
    await signer.getAddress(),
    contractAddress,
  );
  const isApprovedNotEnough = new BigNumber(
    approvedValue.toString(),
  ).isLessThan(value);

  if (isApprovedNotEnough) {
    const approveTx = await usdtContract.approve(contractAddress, value);
    await approveTx.wait();
  }

  const tx = await contract.exactInputSingle(params);
  const trx = await tx.wait();
  return trx;
};
